// Convert string date format - Farmacie
export const changeDateFormat = (inputDate, time) => {
  if (!inputDate || typeof inputDate !== 'string') {
    return null;
  }
  // const ISO_FULL_REGEX =
  //   /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
  // if (ISO_FULL_REGEX.test(inputDate)) {
  //   return inputDate;
  // }
  const match = inputDate
    .trim()
    .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/);

  if (!match) {
    return null;
  }
  let [, dd, mm, yyyy, hh, min] = match;

  // if (hh === undefined || min === undefined) {
  if (time) {
    [hh, min] = time.split(':');
  }

  // padding
  dd = dd.padStart(2, '0');
  mm = mm.padStart(2, '0');
  hh = hh.padStart(2, '0');
  min = min.padStart(2, '0');

  // timezone offset (il server e il client devono essere configurati correttamente,
  // in alternativa servono moment-timezon o luxon
  const date = new Date(`${yyyy}-${mm}-${dd}T${hh}:${min}:00.000Z`);
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const pad = (n) => String(Math.abs(n)).padStart(2, '0');
  const offsetHours = pad(Math.floor(Math.abs(offsetMinutes) / 60));
  return `${yyyy}-${mm}-${dd}T${hh}:${min}:00${sign}${offsetHours}:00`;
};
